{
  "name": "@smej/security-jam",
  "version": "1.0.1",
  "scripts": {
    "pre": "npm run ssss && npm run pug -- -P",
    "pug": "pug projects/index/src --doctype html",
    "ssss": "sass projects/index/src:projects/index/src -I . --no-source-map",
    "sass": "npm run ssss -- --style compressed",
    "cdk": "cdk",
    "diff": "cdk diff --no-change-set",
    "deploy": "cdk deploy --require-approval never --no-previous-parameters",
    "deploy:all": "npm run deploy -- --all",
    "deploy:app": "npm run deploy -- SMEJSecurityJamStack-App",
    "deploy:core": "npm run deploy -- SMEJSecurityJamStack-Core",
    "deploy:game": "npm run deploy -- SMEJSecurityJamStack-Game",
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "dev": "ng build --configuration development",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint --fix"
  },
  "private": true,
  "dependencies": {
    "aws-cdk": "2.142.1",
    "aws-cdk-lib": "2.142.1"
  },
  "devDependencies": {
    "@angular-builders/custom-webpack": "17.0.2",
    "@angular-devkit/build-angular": "17.3.7",
    "@angular-eslint/builder": "17.4.1",
    "@angular-eslint/eslint-plugin": "17.4.1",
    "@angular-eslint/eslint-plugin-template": "17.4.1",
    "@angular-eslint/schematics": "17.4.1",
    "@angular-eslint/template-parser": "17.4.1",
    "@angular/animations": "17.3.9",
    "@angular/cdk": "17.3.9",
    "@angular/cli": "17.3.7",
    "@angular/common": "17.3.9",
    "@angular/compiler": "17.3.9",
    "@angular/compiler-cli": "17.3.9",
    "@angular/core": "17.3.9",
    "@angular/flex-layout": "15.0.0-beta.42",
    "@angular/forms": "17.3.9",
    "@angular/material": "17.3.9",
    "@angular/platform-browser": "17.3.9",
    "@angular/platform-browser-dynamic": "17.3.9",
    "@angular/router": "17.3.9",
    "@aws-amplify/auth": "6.3.2",
    "@aws-amplify/core": "6.2.1",
    "@aws-sdk/client-apigatewaymanagementapi": "3.577.0",
    "@aws-sdk/client-dynamodb": "3.577.0",
    "@aws-sdk/client-scheduler": "3.577.0",
    "@aws-sdk/client-sfn": "3.577.0",
    "@aws-sdk/lib-dynamodb": "3.577.0",
    "@types/aws-lambda": "8.10.138",
    "@types/chart.js": "2.9.41",
    "@types/jasmine": "5.1.4",
    "@types/node": "20.12.12",
    "@typescript-eslint/eslint-plugin": "7.10.0",
    "@typescript-eslint/parser": "7.10.0",
    "aws-amplify": "6.3.2",
    "chart.js": "4.4.3",
    "chartjs-plugin-datalabels": "2.2.0",
    "charts.css": "1.1.0",
    "constructs": "10.3.0",
    "dayjs": "1.11.11",
    "eslint": "8.57.0",
    "eslint-plugin-import": "2.29.1",
    "eslint-plugin-jsdoc": "48.2.5",
    "eslint-plugin-prefer-arrow": "1.2.3",
    "hashids": "2.3.0",
    "jasmine-core": "5.1.2",
    "karma": "6.4.3",
    "karma-chrome-launcher": "3.2.0",
    "karma-coverage": "2.2.1",
    "karma-jasmine": "5.1.0",
    "karma-jasmine-html-reporter": "2.1.0",
    "pug-cli": "github:pugjs/pug-cli",
    "rxjs": "7.8.1",
    "sass": "1.77.2",
    "tslib": "2.6.2",
    "typescript": "5.4.5",
    "zone.js": "0.14.6",
    "@slack/webhook": "7.0.2"
  }
}
